import React from 'react'

const CrosstabDropdown = () => {
  return (
    <div className="crosstab2--dropdown--root">
      <div className="crosstab2--dropdown--col">
        Column A
      </div>
      <div className="crosstab2--dropdown--col">
        Column B
      </div>
      <div className="crosstab2--dropdown--col">
        Column C
      </div>
    </div>
  )
}

export default CrosstabDropdown